// extracted by mini-css-extract-plugin
export var divider = "_me-0";
export var labelWrapper = "_me-2";
export var lineSvg = "_me-1";